import {
  DesktopVersion,
  Image,
  ImageGrid,
  MobileVersion,
  StyledBox,
  Text,
  TextGrid,
  Title,
} from "../styles/NetworkStyles";

import BrazilPin from "../../../../../assets/images/brazil-pin.webp";
import { NetworkForm } from "./NetworkForm/NetworkForm";

const NETWORK_TITLE = "Rede Credenciada";

const NETWORK_DESCRIPTION =
  "O cirurgião dentista é um profissional que a gente tem que confiar. E na rede SulAmérica você tem muitos deles para escolher.";

const Network = () => {
  return (
    <StyledBox id="rede" aria-labelledby="rede-credenciada-title">
      <DesktopVersion container>
        <TextGrid size={{ xs: 12, md: 5 }}>
          <Title id="rede-credenciada-title">{NETWORK_TITLE}</Title>
          <Text>{NETWORK_DESCRIPTION}</Text>
          <NetworkForm />
        </TextGrid>

        <ImageGrid size={{ xs: 12, md: 7 }}>
          <Image src={BrazilPin} loading="lazy" alt="Mapa do Brasil com marcador de localização"/>
        </ImageGrid>
      </DesktopVersion>

      <MobileVersion container>
        <Title>{NETWORK_TITLE}</Title>
        <Text>{NETWORK_DESCRIPTION}</Text>
        <Image src={BrazilPin} />
        <NetworkForm />
      </MobileVersion>
    </StyledBox>
  );
};

export default Network;